<template>
    <CreateUpdateTemplate :routePreventDialog="routePreventDialog" :customClass="'customer-create create-for'"
        v-if="getPermission('customer:create')">
        <template v-slot:header-title>
            <h1 class="form-title d-flex">
                <template v-if="equipmentId > 0"> Update Vehicle </template>
                <template v-else> Add New Vehicle</template>

                <Barcode v-if="unique_barcode" class="my-0 mt-1 mb-0 mr-1 ml-2" :barcode="unique_barcode">
                </Barcode>
            </h1>
        </template>
        <template v-slot:header-action>
            <v-btn v-if="!isCustomer" v-on:click="goBack" :disabled="pageLoading"
                class="mx-2 custom-grey-border custom-bold-button">
                Cancel
            </v-btn>

            <v-btn :disabled="!formValid || pageLoading" :loading="pageLoading"
                class="mx-2 custom-bold-button white--text" v-on:click="updateOrCreate" color="cyan">
                {{ equipmentId > 0 ? 'Update' : 'Create' }} Vehicle
            </v-btn>
        </template>
        <template v-slot:body>
            <v-form ref="assetForm" v-model.trim="formValid" lazy-validation v-on:submit.stop.prevent="updateOrCreate">
                <v-row>
                    <v-col class="iv-custom-field py-0" cols="9" md="9" sm="9">
                        <v-layout>
                            <v-col class="custom-content-container py-0" cols="12" :md="12" :sm="12">
                                <v-layout class="d-block customer-create-new-customer">
                                    <v-row>
                                        <v-col class="iv-custom-field" cols="12" md="12" sm="12">
                                            <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll"
                                                style="height: calc(100vh - 195px); position: relative">
                                                <v-container fluid>
                                                    <v-card flat class="custom-grey-border remove-border-radius">
                                                        <v-card-title class="headline grey lighten-4">
                                                            <h3
                                                                class="font-weight-700 custom-headline color-custom-blue">
                                                                Core Information
                                                            </h3>
                                                        </v-card-title>
                                                        <v-card-text class="p-6 font-size-16">
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 required font-size-16 width-100">Vehicle
                                                                        Plate No.</label>
                                                                    <v-text-field id="Vehicle Plate No." :readonly="asset.asset_type == 'company' &&
                                                                        asset.main_type != 'main_company'
                                                                        ? true
                                                                        : false
                                                                        " v-model.trim="asset.serial_no"
                                                                        :rules="[validateRules.required(asset.serial_no, 'Vehicle Plate No.'),]"
                                                                        dense filled label="Vehicle Plate No." solo flat
                                                                        color="cyan" class="width-100"></v-text-field>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">
                                                                        Ref No.</label>
                                                                    <v-text-field id="model-equipment" dense filled
                                                                        label="Ref No." solo v-model="asset.model" flat
                                                                        color="cyan"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Category</label>
                                                                    <div class="d-flex">
                                                                        <v-autocomplete dense filled color="cyan"
                                                                            item-color="cyan" :items="categoryList"
                                                                            label="Category" solo flat
                                                                            append-outer-icon="mdi-cog"
                                                                            v-on:click:append-outer="
                                                                                manageGroupDialog = true
                                                                                " item-text="text" item-value="text"
                                                                            class="pr-2 width-100"
                                                                            v-model.trim="asset.category">
                                                                            <template v-slot:no-data>
                                                                                <v-list-item>
                                                                                    <v-list-item-content>
                                                                                        <v-list-item-title v-html="'No Category(s) Found.'
                                                                                            "></v-list-item-title>
                                                                                    </v-list-item-content>
                                                                                </v-list-item>
                                                                            </template>
                                                                        </v-autocomplete>
                                                                    </div>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Vehicle
                                                                        Brand</label>
                                                                    <v-text-field id="brand" v-model.trim="asset.brand"
                                                                        dense filled label="Brand" solo flat
                                                                        color="cyan" class="width-100"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Vehicle
                                                                        Model</label>
                                                                    <v-autocomplete hide-details id="model"
                                                                        :items="vehicleModelList" dense flat
                                                                        append-outer-icon="mdi-cog"
                                                                        v-on:click:append-outer="
                                                                            manageVehicleModel = true
                                                                            " filled label="Model" item-color="cyan"
                                                                        v-model="asset.vehicle_model" color="cyan" solo
                                                                        item-text="text" item-value="value">
                                                                        <template v-slot:no-data>
                                                                            <v-list-item>
                                                                                <v-list-item-title
                                                                                    v-html="'No Model(s) Found.'"></v-list-item-title>
                                                                            </v-list-item>
                                                                        </template>
                                                                    </v-autocomplete>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Vehicle
                                                                        Seating Capacity
                                                                    </label>

                                                                    <v-text-field id="vehicle-seating-capacity"
                                                                        v-model.trim="asset.vehicle_seating_capacity"
                                                                        dense filled label="Vehicle Seating Capacity"
                                                                        solo flat color="cyan"
                                                                        class="width-100"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Vehicle
                                                                        Specifications</label>
                                                                    <v-text-field id="vehicle-specifications"
                                                                        v-model.trim="asset.vehicle_specifications"
                                                                        dense filled label="Vehicle Specifications" solo
                                                                        flat color="cyan"
                                                                        class="width-100"></v-text-field>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Road
                                                                        Tax Renewal Date</label>
                                                                    <DatePicker solo flat :mandatory="false"
                                                                        :nullable="true"
                                                                        placeholder="Road Tax Renewal Date"
                                                                        v-model="asset.road_tax_renewal">

                                                                    </DatePicker>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Last
                                                                        Service Mileage</label>
                                                                    <v-text-field id="vehicle-specifications"
                                                                        v-model.trim="asset.last_service_milage" dense
                                                                        filled label="Last Service Mileage" solo flat
                                                                        color="cyan" class="width-100"></v-text-field>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Next
                                                                        Service Mileage</label>
                                                                    <v-text-field id="vehicle-specifications"
                                                                        v-model.trim="asset.next_service_milage" dense
                                                                        filled label="Next Service Mileage" solo flat
                                                                        color="cyan" class="width-100"></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Last
                                                                        Battery Change Date</label>
                                                                    <DatePicker solo flat :mandatory="false"
                                                                        :nullable="true"
                                                                        placeholder="Last Battery Change Date"
                                                                        v-model="asset.last_battery_change">

                                                                    </DatePicker>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Last
                                                                        Tyre Change Date</label>
                                                                    <DatePicker solo flat :mandatory="false"
                                                                        :nullable="true"
                                                                        placeholder="Last Tyre Change Date"
                                                                        v-model="asset.last_tyre_change">

                                                                    </DatePicker>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Last
                                                                        Service Date</label>
                                                                    <DatePicker solo flat :mandatory="false"
                                                                        :nullable="true" placeholder="Last Service Date"
                                                                        v-model="asset.last_service">

                                                                    </DatePicker>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Tags</label>
                                                                    <TagAutoComplete type="equipment"
                                                                        v-model="asset.tags" />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="12">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Description</label>
                                                                    <v-textarea v-model.trim="asset.description"
                                                                        auto-grow dense filled color="cyan"
                                                                        placeholder="Description" solo flat
                                                                        row-height="15" v-on:paste="(e) => onPaste(e)"
                                                                        v-on:keypress="(e) => manageLimit(e)"></v-textarea>
                                                                    <v-col md="12" class="text-right">{{
                                                                        asset.description
                                                                            ? asset.description.length
                                                                            : 0
                                                                    }}/200</v-col>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>

                                                    <v-card flat class="custom-grey-border remove-border-radius mt-3"
                                                        v-if="equipmentId == 0">
                                                        <v-card-title
                                                            class="headline grey lighten-4 d-flex align-center justify-space-between">
                                                            <h3
                                                                class="font-weight-700 custom-headline color-custom-blue mb-0">
                                                                Assign Drivers
                                                            </h3>

                                                            <v-btn color="cyan" class="white--text custom-bold-button"
                                                                depressed tile @click="addMoreDriver()">
                                                                Add More
                                                            </v-btn>
                                                        </v-card-title>
                                                        <v-card-text class="p-6 font-size-16">
                                                            <v-row>
                                                                <v-col lg="12" class="d-flex">
                                                                    <table width="100%" style="table-layout: fixed"
                                                                        class="my-auto py-0 align-items-center" v-if="
                                                                            assign_drivers &&
                                                                            assign_drivers.length > 0
                                                                        ">
                                                                        <tr v-for="(assign_driver, index) in assign_drivers"
                                                                            :key="`create-visit-attachment-${index}`">
                                                                            <td class="">
                                                                                <label
                                                                                    class="pr-2 pl-2 font-weight-700 font-size-16 width-100 required">Driver</label>
                                                                                <v-autocomplete :items="driverList"
                                                                                    dense. filled color="cyan"
                                                                                    item-color="cyan" solo flat
                                                                                     :rules="[
                                                                                        validateRules.required(
                                                                                            assign_driver.driver,
                                                                                            ' Drivers '
                                                                                        ),
                                                                                    ]"
                                                                                    v-model.trim="assign_driver.driver"
                                                                                    placeholder="Select Drivers"
                                                                                    item-text="display_name"
                                                                                    item-value="id"
                                                                                    class="width-100 new-height"
                                                                                    hide-details>
                                                                                    <template v-slot:no-data>
                                                                                        <v-list-item>
                                                                                            <v-list-item-content>
                                                                                                <v-list-item-title
                                                                                                    v-html="'No Drivers(s) Found.'"></v-list-item-title>
                                                                                            </v-list-item-content>
                                                                                        </v-list-item>
                                                                                    </template>
                                                                                </v-autocomplete>
                                                                            </td>
                                                                            <td class="py-0">
                                                                                <label
                                                                                    class="pr-2 pl-2 font-weight-700 font-size-16 width-100 required">Start
                                                                                    Date</label>
                                                                                <DatePicker solo flat :mandatory="false"
                                                                                    :nullable="true"
                                                                                    placeholder="Start Date"
                                                                                    v-model="assign_driver.start_date"
                                                                                    :rules="[
                                                                                        validateRules.required(
                                                                                            assign_driver.start_date,
                                                                                            ' Start Date'
                                                                                        ),
                                                                                    ]"
                                                                                >

                                                                                </DatePicker>
                                                                            </td>
                                                                            <td class="py-0">
                                                                                <label
                                                                                    class="pr-2 pl-2 font-weight-700 font-size-16 width-100 required">End
                                                                                    Date</label>
                                                                                <DatePicker solo flat :mandatory="false"
                                                                                    :nullable="true"
                                                                                    :min-date="assign_driver.start_date"
                                                                                    placeholder="End Date"
                                                                                    v-model="assign_driver.end_date"
                                                                                     :rules="[
                                                                                        validateRules.required(
                                                                                            assign_driver.end_date,
                                                                                            'End Date'
                                                                                        ),
                                                                                    ]"
                                                                                >

                                                                                </DatePicker>
                                                                            </td>
                                                                            <td class="px-0 py-0" width="5%"
                                                                                align="center">
                                                                                <v-btn v-on:click="
                                                                                    removeDriver(index)
                                                                                    " icon class="w-100"
                                                                                    color="red lighten-1">
                                                                                    <v-icon>mdi-delete</v-icon>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                    <v-card flat class="custom-grey-border remove-border-radius mt-3">
                                                        <v-card-title class="headline grey lighten-4">
                                                            <h3
                                                                class="font-weight-700 custom-headline color-custom-blue">
                                                                Documents
                                                            </h3>
                                                        </v-card-title>
                                                        <v-card-text class="p-6 font-size-16">
                                                            <v-row>
                                                                <v-col lg="12">
                                                                    <div class="ml-1">
                                                                        Allowed Extensions:
                                                                        doc,docx,txt,text,rtf,xsl,jpeg,png,gif,zip,rar,pdf,xlsx,word,jpg
                                                                        <br />
                                                                        Max files: 5, Max Size: 5MB
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="12" class="d-flex">
                                                                    <table width="100%" style="table-layout: fixed"
                                                                        class="my-auto py-0 align-items-center" v-if="
                                                                            wtz_attachments &&
                                                                            wtz_attachments.length > 0
                                                                        ">
                                                                        <tr v-for="(file, index) in wtz_attachments"
                                                                            :key="`create-visit-attachment-${index}`">
                                                                            <td class="">
                                                                                <v-file-input hide-details class="px-0"
                                                                                    dense filled solo flat
                                                                                    v-model="file.file"
                                                                                    placeholder="Select File"
                                                                                    prepend-icon=""
                                                                                    prepend-inner-icon="$file"
                                                                                    v-on:change="
                                                                                        updateFileEquipment(
                                                                                            index,
                                                                                            $event,
                                                                                            'eqp_file'
                                                                                        )
                                                                                        " v-on:click:clear="
                                                                                            updateFileEquipment(
                                                                                                index,
                                                                                                $event,
                                                                                                'eqp_file'
                                                                                            )
                                                                                            " color="cyan" />
                                                                            </td>
                                                                            <td class="py-0">
                                                                                <v-text-field hide-details class="px-0"
                                                                                    v-model="file.name"
                                                                                    placeholder="Name" dense filled solo
                                                                                    flat color="cyan" />
                                                                            </td>
                                                                            <td class="px-0 py-0" width="5%"
                                                                                align="center">
                                                                                <v-btn :disabled="wtz_attachments.length < 2
                                                                                    " v-on:click="
                                                                                        removeFileEquipment(index)
                                                                                        " icon class="w-100"
                                                                                    color="red lighten-1">
                                                                                    <v-icon>mdi-delete</v-icon>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                        <tr v-if="
                                                                            wtz_attachments &&
                                                                            wtz_attachments.length < 5
                                                                        ">
                                                                            <td class="" colspan="3">
                                                                                <v-btn color="cyan white--text"
                                                                                    class="custom-bold-button" depressed
                                                                                    v-on:click="addMoreEquipment()"
                                                                                    tile>Add More</v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>

                                                    <v-card v-if="
                                                        asset.is_purchase_info &&
                                                        asset.asset_type == 'company'
                                                    " flat class="custom-grey-border remove-border-radius mt-4">
                                                        <v-card-title class="headline grey lighten-4">
                                                            <h3
                                                                class="font-weight-700 custom-headline color-custom-blue">
                                                                Purchased Information
                                                            </h3>
                                                        </v-card-title>
                                                        <v-card-text class="p-6 font-size-16">
                                                            <v-row>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Cost
                                                                        Price</label>
                                                                    <v-text-field type="number" id="cost_price"
                                                                        v-model.trim="asset.cost_price" dense filled
                                                                        label="Cost Price" solo flat color="cyan"
                                                                        class="width-100"
                                                                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode==46)"></v-text-field>
                                                                </v-col>
                                                                <v-col lg="6">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Purchased
                                                                        On</label>
                                                                    <DatePicker solo flat :mandatory="false"
                                                                        :nullable="true" placeholder="Purchased On"
                                                                        v-model="asset.purchased_on"
                                                                        :default-date="asset.purchased_on">
                                                                    </DatePicker>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col lg="12">
                                                                    <label
                                                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100">Supplier</label>
                                                                    <v-autocomplete :items="supplierList" dense filled
                                                                        color="cyan" item-color="cyan" label="Supplier"
                                                                        solo flat item-text="display_name"
                                                                        item-value="id" class="pl-2 width-100"
                                                                        v-model.trim="asset.vendor">
                                                                        <template v-slot:no-data>
                                                                            <v-list-item>
                                                                                <v-list-item-content>
                                                                                    <v-list-item-title
                                                                                        v-html="'No Supplier(s) Found.'"></v-list-item-title>
                                                                                </v-list-item-content>
                                                                            </v-list-item>
                                                                        </template>
                                                                    </v-autocomplete>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-container>
                                            </perfect-scrollbar>
                                        </v-col>
                                    </v-row>
                                </v-layout>
                            </v-col>
                            <v-col md3>
                                <template>
                                    <v-img :lazy-src="$defaultImage" :src="getProfileImage" max-height="200"
                                        max-width="200" height="200px" width="200px"
                                        class="custom-grey-border custom-border-radius-50 company-image-logo margin-auto">
                                    </v-img>
                                    <div class="margin-auto">
                                        <v-btn class="my-4 custom-bold-button width-100" outlined small
                                            v-on:click="selectImage" color="cyan" :loading="imageLoading"
                                            :disabled="imageLoading">
                                            <template v-if="getProfileImage">Change Image</template>
                                            <template v-else>Upload Image</template>
                                        </v-btn>

                                        <div class="d-none">
                                            <v-file-input ref="uploadImage" v-on:change="updateProfileImage"
                                                :rules="imageRules"
                                                accept="image/png, image/jpeg, image/jpg"></v-file-input>
                                        </div>
                                    </div>
                                </template>
                            </v-col>
                        </v-layout>
                    </v-col>
                </v-row>
            </v-form>

            <template v-if="manageGroupDialog">
                <ManageCategory Vehicle :c-dialog="manageGroupDialog" :category="categoryList"
                    v-on:close-dialog="manageGroupDialog = false" v-on:get-product-category="get_options">
                </ManageCategory>
            </template>

            <template v-if="manageVehicleModel">
                <ManageVehicleModel :d-dialog="manageVehicleModel" :e_models="vehicleModelList"
                    v-on:close-dialog="manageVehicleModel = false" v-on:get-e-vehicle-models="get_options">
                </ManageVehicleModel>
            </template>
        </template>
    </CreateUpdateTemplate>
</template>

<script>
import { currentUser } from "@/core/services/jwt.service";
import CommonMixin from "@/core/plugins/common-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST, CLEAR_ERROR, GET } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { findIndex, forEach, /*  filter  */ } from "lodash";
import {
  /* SET_MESSAGE, */ SET_ERROR,
} from "@/core/services/store/common.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import TagAutoComplete from "@/view/pages/partials/TagAutoCompleteInput";
import ManageCategory from "@/view/pages/partials/Manage-Product-Category.vue";
import ManageVehicleModel from "@/view/pages/partials/Manage-Vehicle-Model.vue";
import DatePicker from "@/view/components/DatePicker.vue";
import MomentJS from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
export default {
    mixins: [CommonMixin, ValidationMixin, CustomerMixin, FileManagerMixin],
    name: "customer-create",
    title: "Create Asset",
    //emits: ['phone-number'],
    data() {
        return {
            allowPurchaseinfo: 0,
            driverList: [],
            showPurchaseInfoTab: true,
            unique_barcode: null,
            pageLoading: false,
            leadId: 0,
            imageLoading: false,
            customerList: [],
            formValid: true,
            formLoading: false,
            files: [
                {
                    file: null,
                    name: null,
                    remark: null,
                    suffix: null,
                    tags: null,
                    search: null,
                    start_date: null,
                    end_date: null,
                    reminder_date: null,
                },
            ],
            equipment_files: [
                {
                    file: null,
                    name: null,
                    remark: null,
                    suffix: null,
                    tags: null,
                    search: null,
                    start_date: null,
                    end_date: null,
                    reminder_date: null,
                },
            ],
            lead: {},
            minDate: null,
            categoryList: [],
            vehicleModelList: [],
            all_currency: [],
            equipmentId: 0,
            manageGroupDialog: false,
            manageVehicleModel: false,
            propertyAddress: {},
            billingAddress: {},
            all_customers: [],
            all_property: [],
            brands: [],
            assetCats: [],
            years: [],
            engineTypes: [],
            insuranceCompany: [],
            products: [],
            supplierList: [],
            equipment_locations: [],
            financeCompanies: [],
            filtered_property: [],
            contactDetail: {},
            contactPerson: [],
            notification: {},
            updatedImg: null,
            machine_types: [],
            machine_models: [],
            asset: {
                vehicle_type: null,
                vehicle_model: null,
                vehicle_seating_capacity: null,
                vehicle_specifications: null,
                cross_rent_month: 1,
                cross_rent_duration_type: "month",
                do_no: null,
                machine_type: null,
                machine_model: 0,
                selling_price: 0,
                batch_number: null,
                check_maintanance: false,
                preventive_duration_type: "month",
                preventive_start_date: MomentJS().format("YYYY-MM-DD"),
                preventive_end_date: null,
                preventive_duration: 0,
                preventive_description: null,
                asset_type: "personal",
                name: null,
                main_type: "main_customer",
                customer: 0,
                brand: null,
                installation_date: null,
                activation_date: null,
                new_asset: false,
                new_end_date: null,
                property: 0,
                product: 0,
                asset_image: null,
                category: null,
                pico_barcode: null,
                serial_no: null,
                location: 0,
                model: null,
                check_warranty: false,
                is_return: false,
                is_purchase_info: false,
                description: null,
                tags: [],
                warranty_start_date: null,
                warranty_end_date: null,
                warranty_duration: 0,
                warranty_duration_type: "month",
                warranty_cost: 0,
                warranty_reminder: [
                    {
                        type: "after",
                        duration: null,
                        duration_type: "Day",
                        reminder_type: null,
                    },
                ],
                company_number: null,
                lp_cert: null,
                owner_ref: null,
                year: null,
                plateform_height: null,
                engine_type: null,
                capacity: null,
                code: null,
                chassis_number: null,
                engine_number: null,
                lta_plate_no: null,
                nea_plate_no: null,
                originial_fork: null,
                noa: null,
                asset_category: null,
                equip_start_date: null,
                equip_end_date: null,
                equip_cost_currency: "SGD",
                purchase_invoice_number: null,
                cost_remark: null,
                purchase_year: null,
                brought_from: null,
                purchase_cost: 0,
                contract_number: null,
                finance_company: null,
                finance_start_date: null,
                finance_end_date: null,
                insurance_company: null,
                insurance_policy: null,
                insurance_start_date: null,
                insurance_end_date: null,

                finance_company_text: null,
                finance_hp_no: null,

                import_arrival_date: null,
                import_permit_no: null,
                import_bol_no: null,
                machinery_all_risk: null,
                hour_meter: null,
                breakdown_log: null,
                cross_rental_cost_currency: "SGD",
                cross_rent_cost: 0,
                cross_rent_invoice_number: null,
                cross_rent_finance_company: null,
                cross_rent_contract_number: null,
                cross_rent_finance_start_date: null,
                cross_rent_finance_end_date: null,
                cross_rent_insurance_company: null,
                cross_rent_insurance_policy: null,
                cross_rent_insurance_start_date: null,
                cross_rent_insurance_end_date: null,
                cross_rent_supplier_name: null,
                cross_rent_end_date: null,
                cross_rent_remark: null,
                cross_rent_start_date: null,
                reminder_frequency: 1,
                set_reminder: false,
                cert_start_date: null,
                cert_expiry_date: null,
                cert_reminder_type: "one_time_reminder",
                reminder_start_date: null,
                reminder_end_date: null,
                last_tyre_change: null,
                last_battery_change: null,
                last_service_milage: null,
                next_service_milage: null,
                last_service: null,
                road_tax_renewal: null
            },
             assign_drivers: Array({
                driver: null,
                start_date: null,
                end_date: null,
            }),
            wtz_attachments: Array({
                file: null,
                url: null,
                name: null,
            }),
            cert_attachments: Array({
                file: null,
                url: null,
                name: null,
            }),
            wtx_attachments: Array({
                file: null,
                url: null,
                name: null,
            }),
            mtx_attachments: Array({
                file: null,
                url: null,
                name: null,
            }),
            tabs: [
                {
                    title: "Overview",
                    icon: "mdi-credit-card",
                    key: "overview",
                    permission: "customer",
                    status: true,
                },
            ],
            isCustomerCreated: false,
            isAddressCreated: false,
            options: {},
            steps: {
                details: false,
                "contact-person": true,
                property: true,
                maintenance: true,
                notification: true,
            },
        };
    },
    props: {
        isCustomer: {
            type: Boolean,
            default: false,
        },
        isCreate: {
            type: Boolean,
            default: false,
        },
        customerId: {
            type: Number,
            default: 0,
        },
    },
    components: {
        TagAutoComplete,
        CreateUpdateTemplate,
        ManageCategory,
        DatePicker,
        Barcode,
        ManageVehicleModel
    },
    watch: {
        formValid(param) {
            if (param) {
                this.$store.dispatch(CLEAR_ERROR, {});
            }
        },
    },
    methods: {
        getUserDetail() {
            const _this = this;
            _this.pageLoading = true;
            _this.$store
                .dispatch(GET, {
                    url: "current-user",
                })
                .then(({ data }) => {
                    if (data) {
                        _this.allowPurchaseinfo = data?.is_manager;
                    }
                })
                .catch((error) => {
                    _this.logError(error);
                })
                .finally(() => {
                    _this.pageLoading = false;
                });
        },
        filterModels(machine = 0) {
            this.machine_models = [];

            this.machine_types.map((row) => {
                if (row.id == machine) {
                    this.machine_models = row.subcategory;
                }
            });
        },
        updateFileEquipment(indexFile, file, type) {
            if (type == "cert_file") {
                if (file && file.name) {
                    this.cert_attachments[indexFile].name = file.name
                        .split(".")
                        .slice(0, -1)
                        .join(".");
                    this.cert_attachments[indexFile].suffix = `.${file.name
                        .split(".")
                        .pop()};`;
                } else {
                    this.cert_attachments[indexFile].name = null;
                    this.cert_attachments[indexFile].suffix = null;
                }
            }
            if (type == "eqp_file") {
                if (file && file.name) {
                    this.wtz_attachments[indexFile].name = file.name
                        .split(".")
                        .slice(0, -1)
                        .join(".");
                    this.wtz_attachments[indexFile].suffix = `.${file.name
                        .split(".")
                        .pop()};`;
                } else {
                    this.wtz_attachments[indexFile].name = null;
                    this.wtz_attachments[indexFile].suffix = null;
                }
            }
        },
        get_Equipment() {
            this.$store
                .dispatch(GET, { url: `equipment/${this.equipmentId}` })
                .then(({ data }) => {
                    console.log({test:data.last_battery_change})
                    this.unique_barcode = data.barcode;

                    (this.updatedImg = data.image ? data.image : null),
                        (this.asset.name = data.name ? data.name : null);
                    this.asset.main_type = data.main_type ? data.main_type : null;
                    this.asset.tags = data.tags;

                    this.asset.end_life = data.end_life ? data.end_life : null;
                    this.asset.company_number = data.company_number
                        ? data.company_number
                        : null;
                    this.asset.vehicle_type = data.vehicle_type;

                    this.asset.vehicle_seating_capacity = data.vehicle_seating_capacity
                        ? data.vehicle_seating_capacity
                        : null;


                    this.asset.vehicle_model = data.vehicle_model;

                    this.asset.description = data.description;

                    this.asset.vehicle_specifications = data.vehicle_specifications;

                    
                    this.asset.brand = data.brand ? data.brand : null;
                    this.asset.installation_date = data.installation_date
                        ? data.installation_date
                        : null;
                    this.asset.activation_date = data.activation_date
                        ? data.activation_date
                        : null;
                    this.asset.new_asset = data.new_asset == 1 ? true : false;

                    this.asset.new_end_date = data.new_end_date
                        ? data.new_end_date
                        : null;
                    this.asset.product = data.product ? data.product : 0;
                    this.asset.category = data.category ? data.category : null;
                    this.asset.asset_image = data.image ? data.image : null;
                    this.asset.model = data.model ? data.model : null;
                    this.asset.location =
                        data.location && data.location.id
                            ? this.lodash.toString(data.location.id)
                            : null;

                    this.asset.serial_no = data.serial_no ? data.serial_no : null;
                    this.asset.machine_type = data.machine_type ? data.machine_type : 0;
                    this.asset.machine_model = data.machine_model
                        ? data.machine_model
                        : 0;

                    if (this.asset.machine_type) {
                        this.filterModels(this.asset.machine_type);
                    }

                    
                    this.asset.cost_price = data.cost_price ? data.cost_price : 0;
                    this.asset.vendor =
                        data.supplier && data.supplier.id ? data.supplier.id : 0;

                    this.asset.description = data.description ? data.description : null;

                    this.asset.batch_number =
                        data && data.batch_number ? data.batch_number : null;
                    this.asset.selling_price =
                        data && data.selling_price ? data.selling_price : null;

                    this.asset.asset_image = data.image;

                    this.asset.lp_cert =
                        data && data.lp_cert && data.lp_cert != "null"
                            ? data.lp_cert
                            : null;
                    this.asset.owner_ref =
                        data && data.owner_ref && data.owner_ref != "null"
                            ? data.owner_ref
                            : null;
                    this.asset.year =
                        data && data.year && data.year != "null" ? data.year : null;
                    this.asset.plateform_height =
                        data && data.plateform_height && data.plateform_height != "null"
                            ? data.plateform_height
                            : null;
                    this.asset.engine_type =
                        data && data.engine_type && data.engine_type != "null"
                            ? data.engine_type
                            : null;
                    this.asset.capacity =
                        data && data.capacity && data.capacity != "null"
                            ? data.capacity
                            : null;
                    this.asset.code =
                        data && data.code && data.code != "null" ? data.code : null;
                    this.asset.chassis_number =
                        data && data.chassis_number && data.chassis_number != "null"
                            ? data.chassis_number
                            : null;
                    this.asset.engine_number =
                        data && data.engine_number && data.engine_number != "null"
                            ? data.engine_number
                            : null;
                    this.asset.lta_plate_no =
                        data && data.lta_plate_no && data.lta_plate_no != "null"
                            ? data.lta_plate_no
                            : null;
                    this.asset.nea_plate_no =
                        data && data.nea_plate_no && data.nea_plate_no != "null"
                            ? data.nea_plate_no
                            : null;
                    this.asset.originial_fork =
                        data && data.originial_fork && data.originial_fork != "null"
                            ? data.originial_fork
                            : null;
                    this.asset.noa =
                        data && data.noa && data.noa != "null" ? data.noa : null;
                    this.asset.asset_category =
                        data && data.asset_type && data.asset_type != "null"
                            ? data.asset_type
                            : null;
                    this.asset.asset_type =
                        data && data.type && data.type != "null" ? data.type : null;
                    this.asset.equip_start_date =
                        data && data.equip_start_date && data.equip_start_date != "null"
                            ? data.equip_start_date
                            : null;
                    this.asset.equip_end_date =
                        data && data.equip_end_date && data.equip_end_date != "null"
                            ? data.equip_end_date
                            : null;
                    this.asset.machinery_all_risk =
                        data && data.machinery_all_risk && data.machinery_all_risk != "null"
                            ? data.machinery_all_risk
                            : null;
                    this.asset.hour_meter =
                        data && data.hour_meter && data.hour_meter != "null"
                            ? data.hour_meter
                            : null;
                    
                    this.asset.do_no = data.do_no ? data.do_no : null;
                    this.asset.last_battery_change = data.last_battery_change ? data.last_battery_change : null;
                    this.asset.last_service = data.last_service ? data.last_service : null;
                    this.asset.last_service_milage = data.last_service_milage ? data.last_service_milage : null;
                    this.asset.last_tyre_change = data.last_tyre_change ? data.last_tyre_change : null;
                    this.asset.road_tax_renewal = data.road_tax_renewal ? data.road_tax_renewal : null;
                    this.asset.next_service_milage = data.next_service_milage ? data.next_service_milage : null;
                })
                .catch((error) => {
                    this.logError(error);
                });
        },
        get_options() {
            this.$store
                .dispatch(GET, { url: "equipment/options" })
                .then(({ data }) => {
                    this.customerList = data.customers;
                    this.supplierList = data.suppliers;
                    this.all_property = data.properties;
                    if (!this.equipmentId && this.customerId && this.isCustomer) {
                        this.filter_property(this.customerId);
                    }

                    if (data.machine_types) {
                        this.machine_types = data?.machine_types;
                        //this.filterModels();
                    }
                    this.driverList = data.drivers ? data.drivers : [];
                    this.brands = data.brands;
                    this.assetCats = data.asset_types ? data.asset_types : [];
                    this.engineTypes = data.engine_types ? data.engine_types : [];
                    this.insuranceCompany = data.insurance_companies
                        ? data.insurance_companies
                        : [];
                    this.financeCompanies = data.finance_companies
                        ? data.finance_companies
                        : [];

                    this.years = data.years ? data.years : [];
                    this.all_currency = data.all_currency ? data.all_currency : [];

                    this.categoryList = data.category;
                    this.vehicleModelList = data.vehicle_models;
                    this.products = data.products;
                    this.equipment_locations = data.equipment_locations;
                    if (!this.equipmentId) {
                        this.unique_barcode = data && data.barcode;
                    }
                    //added here for site loc empty issue on update
                    if (this.equipmentId > 0) {
                        this.get_Equipment();
                    }
                    /* this.filtered_property = this.lodash.filter(this.all_property, {
                      customer: this.asset.customer,
                    }); */
                })
                .catch((error) => {
                    this.logError(error);
                });
        },
        filter_property(param) {
            this.filtered_property = this.lodash.filter(this.all_property, {
                customer: param,
            });
        },
        addMoreEquipment() {
            this.wtz_attachments.push({
                file: null,
                url: null,
                name: null,
            });
        },
        addMoreDriver() {
            this.assign_drivers.push({
                driver: null,
                start_date: null,
                end_date: null,
            });
        },
        removeFileEquipment(index) {
            this.wtz_attachments.splice(index, 1);
            if (this.wtz_attachments.length < 1) {
                this.addMoreEquipment();
            }
        },
        removeDriver(index) {
            this.assign_drivers.splice(index, 1);
        },
        updateProfileImage(param) {
            const _this = this;
            _this
                .uploadAttachment(param)
                .then((response) => {
                    let data = _this.lodash.head(response);
                    _this.asset.asset_image =
                        data && data.file && data.file.url ? data.file.url : null;
                })
                .catch((error) => {
                    _this.logError(error);
                })
                .finally(() => {
                    _this.imageLoading = false;
                });
        },
        selectImage() {
            this.$refs["uploadImage"].$refs["input"].click();
        },
        ChangeGroupRadio(data = "") {
            if (data == "cross-rent") {
                data = 1;
                this.showPurchaseInfoTab = false;
            } else {
                data = 0;
                this.showPurchaseInfoTab = true;
            }
            let maintenanceIndex = findIndex(
                this.tabs,
                (row) => row.key == "cross-rent"
            );
            this.tabs[maintenanceIndex].status =
                data == "0" || data == 0 ? false : true;
        },
        manageLimit(e) {
            if (this.asset.description && this.asset.description.length > 199) {
                e.preventDefault();
            }
        },
        onPaste(e) {
            let coppied = e.clipboardData.getData("Text");
            let preVal = this.asset.description;
            let finalval = String(preVal) + String(coppied);
            if (Number(finalval.length) > 199) {
                let trimValue = finalval.substring(0, 200);
                this.asset.description = trimValue;
                e.preventDefault();
            }
        },

        async updateOrCreate() {
            const _this = this;
            const formErrors = _this.validateForm(_this.$refs.assetForm);

            if (formErrors.length) {
                _this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
                return false;
            }

            if (!_this.$refs.assetForm.validate()) {
                return false;
            }

            if (this.asset.check_warranty && !this.asset.warranty_start_date) {
                ErrorEventBus.$emit(
                    "update:error",
                    InitializeError("Warranty start date is required")
                );
                return false;
            }
            if (this.asset.check_warranty && !this.asset.warranty_end_date) {
                ErrorEventBus.$emit(
                    "update:error",
                    InitializeError("Warranty end date is required")
                );
                return false;
            }

            let formData = new FormData();
            formData.append("type", this.asset.asset_type);


            if (this.asset.main_type == "main_company") {
                formData.append("customer", 0);
                formData.append("property", 0);
            }
            if (this.asset.main_type == "main_customer") {
                formData.append(
                    "customer",
                    this.asset.customer ? this.asset.customer : this.customerId
                );
                formData.append(
                    "property",
                    this.asset.property ? this.asset.property : 0
                );
            }

            formData.append("name", this.asset.name ? this.asset.name : 0);

            if (this.asset.vehicle_type) {
                formData.append("vehicle_type", this.asset.vehicle_type);
            }

            if (this.asset.vehicle_model) {
                formData.append("vehicle_model", this.asset.vehicle_model);
            }


            if (this.asset.vehicle_seating_capacity) {
                formData.append("vehicle_seating_capacity", this.asset.vehicle_seating_capacity);
            }

            if (this.asset.vehicle_specifications) {
                formData.append("vehicle_specifications", this.asset.vehicle_specifications);
            }

            formData.append(
                "machine_type",
                this.asset.machine_type ? this.asset.machine_type : 0
            );
            formData.append(
                "machine_model",
                this.asset.machine_model ? this.asset.machine_model : 0
            );

            formData.append(
                "serial_no",
                this.asset.serial_no ? this.asset.serial_no : null
            );
            if (this.asset && this.asset.category) {
                formData.append(
                    "category",
                    this.asset.category ? this.asset.category : null
                );
            }
            if (this.asset && this.asset.installation_date) {
                formData.append(
                    "installation_date",
                    this.asset.installation_date ? this.asset.installation_date : null
                );
            }
            if (this.asset && this.asset.activation_date) {
                formData.append(
                    "activation_date",
                    this.asset.activation_date ? this.asset.activation_date : null
                );
            }
            formData.append(
                "new_asset",
                this.asset.new_asset ? this.asset.new_asset : false
            );
            if (this.asset && this.asset.new_end_date) {
                formData.append(
                    "new_end_date",
                    this.asset.new_end_date ? this.asset.new_end_date : null
                );
            }
            /*  if (this.asset && this.asset.main_type && !this.isCustomer) { */
            formData.append(
                "main_type",
                this.asset.main_type ? this.asset.main_type : null
            );
            /*   } */
            if (this.asset && this.asset.end_life) {
                formData.append(
                    "end_life",
                    this.asset.end_life ? this.asset.end_life : null
                );
            }
            if (this.asset && this.asset.company_number) {
                formData.append(
                    "company_number",
                    this.asset.company_number ? this.asset.company_number : null
                );
            }
            if (this.asset && this.asset.cost) {
                formData.append("cost", this.asset.cost ? this.asset.cost : 0);
            }
            if (this.asset && this.asset.location) {
                formData.append(
                    "location",
                    this.asset.location ? this.asset.location : 0
                );
            }
            if (this.asset && this.asset.product) {
                formData.append("product", this.asset.product ? this.asset.product : 0);
            }
            if (this.asset && this.asset.model) {
                formData.append("model", this.asset.model ? this.asset.model : null);
            }
            if (this.asset && this.asset.asset_image) {
                formData.append("asset_image", this.asset.asset_image);
            }

            if (this.asset && this.asset.brand) {
                formData.append("brand", this.asset.brand ? this.asset.brand : null);
            }
            if (this.asset && this.asset.description) {
                formData.append(
                    "description",
                    this.asset.description ? this.asset.description : null
                );
            }
            if (this.asset && this.asset.check_warranty) {
                formData.append("check_warranty", this.asset.check_warranty ? 1 : 0);
            }
            if (this.asset && this.asset.is_purchase_info) {
                formData.append(
                    "is_purchase_info",
                    this.asset.is_purchase_info ? 1 : 0
                );
            }
            if (this.asset && this.asset.is_purchase_info && this.asset.cost_price) {
                formData.append(
                    "cost_price",
                    this.asset.cost_price ? this.asset.cost_price : 0
                );
            }
            if (
                this.asset &&
                this.asset.is_purchase_info &&
                this.asset.purchased_on
            ) {
                formData.append(
                    "purchased_on",
                    this.asset.purchased_on ? this.asset.purchased_on : null
                );
            }
            if (this.asset && this.asset.is_purchase_info && this.asset.vendor) {
                formData.append("vendor", this.asset.vendor ? this.asset.vendor : 0);
            }
            if (
                this.asset &&
                this.asset.check_warranty &&
                this.asset.warranty_duration
            ) {
                formData.append(
                    "warranty_duration",
                    this.asset.warranty_duration ? this.asset.warranty_duration : 0
                );
            }
            if (
                this.asset &&
                this.asset.check_warranty &&
                this.asset.warranty_duration_type
            ) {
                formData.append(
                    "warranty_duration_type",
                    this.asset.warranty_duration_type
                        ? this.asset.warranty_duration_type
                        : null
                );
            }

            if (
                this.asset &&
                this.asset.check_warranty &&
                this.asset.warranty_start_date
            ) {
                formData.append(
                    "warranty_start_date",
                    this.asset.warranty_start_date ? this.asset.warranty_start_date : null
                );
            }
            if (
                this.asset &&
                this.asset.check_warranty &&
                this.asset.warranty_end_date
            ) {
                formData.append(
                    "warranty_end_date",
                    this.asset.warranty_end_date ? this.asset.warranty_end_date : null
                );
            }
            if (this.asset && this.asset.check_warranty && this.asset.warranty_cost) {
                formData.append(
                    "warranty_cost",
                    this.asset.warranty_cost ? this.asset.warranty_cost : 0
                );
            }

            if (
                this.asset &&
                this.asset.tags &&
                this.asset.tags.length &&
                this.asset.tags.length > 0
            ) {
                for (let i = 0; i < this.asset.tags.length; i++) {
                    if (
                        this.asset.tags &&
                        this.asset.tags[i] &&
                        this.asset.tags[i].type
                    ) {
                        formData.append(`tags[${i}][type]`, this.asset.tags[i].type);
                    }
                    if (
                        this.asset.tags &&
                        this.asset.tags[i] &&
                        this.asset.tags[i].color
                    ) {
                        formData.append(`tags[${i}][color]`, this.asset.tags[i].color);
                    }
                    if (
                        this.asset.tags &&
                        this.asset.tags[i] &&
                        this.asset.tags[i].text
                    ) {
                        formData.append(`tags[${i}][text]`, this.asset.tags[i].text);
                    }
                }
            }
            if (
                this.asset &&
                this.asset.warranty_reminder &&
                this.asset.warranty_reminder.length &&
                this.asset.warranty_reminder.length > 0
            ) {
                for (let i = 0; i < this.asset.warranty_reminder.length; i++) {
                    formData.append(
                        `warranty_reminder[${i}][type]`,
                        this.asset.warranty_reminder[i].type
                            ? this.asset.warranty_reminder[i].type
                            : 0
                    );

                    if (
                        this.asset.warranty_reminder &&
                        this.asset.warranty_reminder[i] &&
                        this.asset.warranty_reminder[i].duration
                    ) {
                        formData.append(
                            `warranty_reminder[${i}][duration]`,
                            this.asset.warranty_reminder[i].duration
                        );
                    }
                    if (
                        this.asset.warranty_reminder &&
                        this.asset.warranty_reminder[i] &&
                        this.asset.warranty_reminder[i].duration_type
                    ) {
                        formData.append(
                            `warranty_reminder[${i}][duration_type]`,
                            this.asset.warranty_reminder[i].duration_type
                        );
                    }
                    if (
                        this.asset.warranty_reminder &&
                        this.asset.warranty_reminder[i] &&
                        this.asset.warranty_reminder[i].reminder_type
                    ) {
                        formData.append(
                            `warranty_reminder[${i}][reminder_type]`,
                            this.asset.warranty_reminder[i].reminder_type
                        );
                    }
                }
            }

            //preventive
            if (this.asset && this.asset.check_maintanance) {
                formData.append(
                    "has_preventive_maintanance",
                    this.asset.check_maintanance ? this.asset.check_maintanance : 0
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_cost
            ) {
                formData.append(
                    "preventive_cost",
                    this.asset.preventive_cost ? this.asset.preventive_cost : 0
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_description
            ) {
                formData.append(
                    "preventive_description",
                    this.asset.preventive_description
                        ? this.asset.preventive_description
                        : null
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_end_date
            ) {
                formData.append(
                    "preventive_end_date",
                    this.asset.preventive_end_date ? this.asset.preventive_end_date : null
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_start_date
            ) {
                formData.append(
                    "preventive_start_date",
                    this.asset.preventive_start_date
                        ? this.asset.preventive_start_date
                        : null
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_duration_type
            ) {
                formData.append(
                    "preventive_duration_type",
                    this.asset.preventive_duration_type
                        ? this.asset.preventive_duration_type
                        : null
                );
            }
            if (
                this.asset &&
                this.asset.check_maintanance &&
                this.asset.preventive_duration
            ) {
                formData.append(
                    "preventive_duration",
                    this.asset.preventive_duration ? this.asset.preventive_duration : 0
                );
            }

            formData.append(
                "batch_number",
                this.asset.batch_number ? this.asset.batch_number : null
            );

            //Extended info
            formData.append(
                "lp_cert",
                this.asset.lp_cert ? this.asset.lp_cert : null
            );
            formData.append(
                "owner_ref",
                this.asset.owner_ref ? this.asset.owner_ref : null
            );
            formData.append("year", this.asset.year ? this.asset.year : null);
            formData.append(
                "plateform_height",
                this.asset.plateform_height ? this.asset.plateform_height : null
            );
            formData.append(
                "engine_type",
                this.asset.engine_type ? this.asset.engine_type : null
            );
            formData.append(
                "capacity",
                this.asset.capacity ? this.asset.capacity : null
            );
            formData.append("code", this.asset.code ? this.asset.code : null);
            formData.append(
                "chassis_number",
                this.asset.chassis_number && this.asset.chassis_number != "null"
                    ? this.asset.chassis_number
                    : null
            );
            formData.append(
                "engine_number",
                this.asset.engine_number && this.asset.engine_number != "null"
                    ? this.asset.engine_number
                    : null
            );
            formData.append(
                "lta_plate_no",
                this.asset.lta_plate_no ? this.asset.lta_plate_no : null
            );
            formData.append(
                "nea_plate_no",
                this.asset.nea_plate_no ? this.asset.nea_plate_no : null
            );
            formData.append(
                "originial_fork",
                this.asset.originial_fork ? this.asset.originial_fork : null
            );
            formData.append("noa", this.asset.noa ? this.asset.noa : null);
            formData.append(
                "equip_start_date",
                this.asset.equip_start_date ? this.asset.equip_start_date : ""
            );
            formData.append(
                "equip_end_date",
                this.asset.equip_end_date ? this.asset.equip_end_date : ""
            );
            formData.append(
                "machinery_all_risk",
                this.asset.machinery_all_risk ? this.asset.machinery_all_risk : null
            );
            formData.append(
                "hour_meter",
                this.asset.hour_meter ? this.asset.hour_meter : ""
            );
            formData.append(
                "breakdown_log",
                this.asset.breakdown_log ? this.asset.breakdown_log : ""
            );

            formData.append(
                "purchase_cost",
                this.asset.purchase_cost ? this.asset.purchase_cost : null
            );
            formData.append(
                "equip_cost_currency",
                this.asset.equip_cost_currency ? this.asset.equip_cost_currency : null
            );
            formData.append(
                "purchase_invoice_number",
                this.asset.purchase_invoice_number
                    ? this.asset.purchase_invoice_number
                    : null
            );
            formData.append(
                "cost_remark",
                this.asset.cost_remark ? this.asset.cost_remark : null
            );
            formData.append(
                "purchase_year",
                this.asset.purchase_year ? this.asset.purchase_year : null
            );
            formData.append(
                "brought_from",
                this.asset.brought_from ? this.asset.brought_from : null
            );
            formData.append(
                "finance_company",
                parseInt(this.asset.finance_company)
                    ? parseInt(this.asset.finance_company)
                    : 0
            );
            formData.append(
                "contract_number",
                this.asset.contract_number ? this.asset.contract_number : null
            );
            formData.append(
                "finance_start_date",
                this.asset.finance_start_date ? this.asset.finance_start_date : ""
            );
            formData.append(
                "finance_end_date",
                this.asset.finance_end_date ? this.asset.finance_end_date : ""
            );
            formData.append(
                "insurance_company",
                this.asset.insurance_company ? this.asset.insurance_company : null
            );
            formData.append(
                "finance_company_text",
                this.asset.finance_company_text ? this.asset.finance_company_text : null
            );
            formData.append(
                "finance_hp_no",
                this.asset.finance_hp_no ? this.asset.finance_hp_no : null
            );
            formData.append(
                "insurance_policy",
                this.asset.insurance_policy ? this.asset.insurance_policy : null
            );
            formData.append(
                "insurance_start_date",
                this.asset.insurance_start_date ? this.asset.insurance_start_date : ""
            );
            formData.append(
                "insurance_end_date",
                this.asset.insurance_end_date ? this.asset.insurance_end_date : ""
            );

            formData.append(
                "import_arrival_date",
                this.asset.import_arrival_date ? this.asset.import_arrival_date : ""
            );
            formData.append(
                "import_permit_no",
                this.asset.import_permit_no ? this.asset.import_permit_no : null
            );
            formData.append(
                "import_bol_no",
                this.asset.import_bol_no ? this.asset.import_bol_no : null
            );
            formData.append("do_no", this.asset.do_no ? this.asset.do_no : null);

            //cross rent info
            formData.append(
                "cross_rental_cost_currency",
                this.asset.cross_rental_cost_currency
                    ? this.asset.cross_rental_cost_currency
                    : null
            );
            formData.append(
                "cross_rent_cost",
                this.asset.cross_rent_cost ? this.asset.cross_rent_cost : null
            );
            formData.append(
                "cross_rent_invoice_number",
                this.asset.cross_rent_invoice_number
                    ? this.asset.cross_rent_invoice_number
                    : null
            );
            formData.append(
                "cross_rent_finance_company",
                parseInt(this.asset.cross_rent_finance_company)
                    ? parseInt(this.asset.cross_rent_finance_company)
                    : 0
            );
            formData.append(
                "cross_rent_contract_number",
                this.asset.cross_rent_contract_number
                    ? this.asset.cross_rent_contract_number
                    : null
            );
            formData.append(
                "cross_rent_finance_start_date",
                this.asset.cross_rent_finance_start_date
                    ? this.asset.cross_rent_finance_start_date
                    : ""
            );
            formData.append(
                "cross_rent_finance_end_date",
                this.asset.cross_rent_finance_end_date
                    ? this.asset.cross_rent_finance_end_date
                    : ""
            );
            formData.append(
                "cross_rent_insurance_company",
                this.asset.cross_rent_insurance_company
                    ? this.asset.cross_rent_insurance_company
                    : null
            );
            formData.append(
                "cross_rent_insurance_policy",
                this.asset.cross_rent_insurance_policy
                    ? this.asset.cross_rent_insurance_policy
                    : null
            );
            formData.append(
                "cross_rent_insurance_start_date",
                this.asset.cross_rent_insurance_start_date
                    ? this.asset.cross_rent_insurance_start_date
                    : ""
            );
            formData.append(
                "cross_rent_insurance_end_date",
                this.asset.cross_rent_insurance_end_date
                    ? this.asset.cross_rent_insurance_end_date
                    : ""
            );

            formData.append(
                "cross_rent_supplier_name",
                this.asset.cross_rent_supplier_name
                    ? this.asset.cross_rent_supplier_name
                    : ""
            );
            formData.append(
                "cross_rent_end_date",
                this.asset.cross_rent_end_date &&
                    this.asset.cross_rent_end_date != "null"
                    ? this.asset.cross_rent_end_date
                    : null
            );
            formData.append(
                "cross_rent_start_date",
                this.asset.cross_rent_start_date &&
                    this.asset.cross_rent_start_date != "null"
                    ? this.asset.cross_rent_start_date
                    : null
            );
            formData.append(
                "cross_rent_remark",
                this.asset.cross_rent_remark && this.asset.cross_rent_remark != "null"
                    ? this.asset.cross_rent_remark
                    : null
            );
            formData.append(
                "cross_rent_duration_type",
                this.asset.cross_rent_duration_type &&
                    this.asset.cross_rent_duration_type != "null"
                    ? this.asset.cross_rent_duration_type
                    : "month"
            );
            formData.append(
                "cross_rent_month",
                this.asset.cross_rent_month && this.asset.cross_rent_month != "null"
                    ? this.asset.cross_rent_month
                    : 1
            );

            formData.append(
                "asset_category",
                this.asset.asset_category ? this.asset.asset_category : null
            );

            formData.append(
                "selling_price",
                this.asset.selling_price ? this.asset.selling_price : 0
            );

            if (
                this.wtx_attachments &&
                this.wtx_attachments.length &&
                this.wtx_attachments.length > 0
            ) {
                for (let i = 0; i < this.wtx_attachments.length; i++) {
                    if (
                        this.wtx_attachments &&
                        this.wtx_attachments[i] &&
                        this.wtx_attachments[i].file
                    ) {
                        formData.append(`file[${i}][file]`, this.wtx_attachments[i].file);
                        formData.append(`file[${i}][name]`, this.wtx_attachments[i].name);
                    }
                }
            }

            if (
                this.mtx_attachments &&
                this.mtx_attachments.length &&
                this.mtx_attachments.length > 0
            ) {
                for (let i = 0; i < this.mtx_attachments.length; i++) {
                    if (
                        this.mtx_attachments &&
                        this.mtx_attachments[i] &&
                        this.mtx_attachments[i].file
                    ) {
                        formData.append(
                            `maintananace_file[${i}][file]`,
                            this.mtx_attachments[i].file
                        );
                        formData.append(
                            `maintananace_file[${i}][name]`,
                            this.mtx_attachments[i].name
                        );
                    }
                }
            }

            //equipment files
            if (
                this.wtz_attachments &&
                this.wtz_attachments.length &&
                this.wtz_attachments.length > 0
            ) {
                for (let i = 0; i < this.wtz_attachments.length; i++) {
                    if (
                        this.wtz_attachments &&
                        this.wtz_attachments[i] &&
                        this.wtz_attachments[i].file
                    ) {
                        formData.append(
                            `equipment_file[${i}][file]`,
                            this.wtz_attachments[i].file
                        );
                        formData.append(
                            `equipment_file[${i}][name]`,
                            this.wtz_attachments[i].name
                        );
                    }
                }
            }


            if (this.assign_drivers && this.assign_drivers.length > 0 && this.equipmentId == 0) {
                forEach(this.assign_drivers, (row, index) => {

                     if (row.driver && row.start_date && row.end_date) {

                          formData.append(`assign_drivers[${index}][driver]`, row.driver);
                          formData.append(`assign_drivers[${index}][start_date]`, row.start_date);
                          formData.append(`assign_drivers[${index}][end_date]`, row.end_date);
                    }
                })
            }

            if (
                this.cert_attachments &&
                this.cert_attachments.length &&
                this.cert_attachments.length > 0
            ) {
                for (let i = 0; i < this.cert_attachments.length; i++) {
                    if (
                        this.cert_attachments &&
                        this.cert_attachments[i] &&
                        this.cert_attachments[i].file
                    ) {
                        formData.append(
                            `cert_equipment_file[${i}][file]`,
                            this.cert_attachments[i].file
                        );
                        formData.append(
                            `cert_equipment_file[${i}][name]`,
                            this.cert_attachments[i].name
                        );
                    }
                }
            }

            if (this.asset.cert_start_date) {
                formData.append(
                    "cert_start_date",
                    this.asset.cert_start_date ? this.asset.cert_start_date : null
                );
            }
            if (this.asset.cert_expiry_date) {
                formData.append(
                    "cert_expiry_date",
                    this.asset.cert_expiry_date ? this.asset.cert_expiry_date : null
                );
            }
            formData.append(
                "set_reminder",
                this.asset.set_reminder ? this.asset.set_reminder : false
            );
            if (this.asset.cert_reminder_type) {
                formData.append(
                    "cert_reminder_type",
                    this.asset.cert_reminder_type ? this.asset.cert_reminder_type : ""
                );
            }
            if (this.asset.reminder_start_date) {
                formData.append(
                    "reminder_start_date",
                    this.asset.reminder_start_date ? this.asset.reminder_start_date : ""
                );
            }
            if (this.asset.reminder_frequency) {
                formData.append(
                    "reminder_frequency",
                    this.asset.reminder_frequency ? this.asset.reminder_frequency : ""
                );
            }
            if (this.asset.reminder_end_date) {
                formData.append(
                    "reminder_end_date",
                    this.asset.reminder_end_date ? this.asset.reminder_end_date : ""
                );
            }

            if (this.asset.road_tax_renewal) {
                formData.append(
                    "road_tax_renewal",
                    this.asset.road_tax_renewal ? this.asset.road_tax_renewal : ""
                );
            }
            if (this.asset.last_service) {
                formData.append(
                    "last_service",
                    this.asset.last_service ? this.asset.last_service : ""
                );
            }
            if (this.asset.last_service_milage) {
                formData.append(
                    "last_service_milage",
                    this.asset.last_service_milage ? this.asset.last_service_milage : ""
                );
            }
            if (this.asset.next_service_milage) {
                formData.append(
                    "next_service_milage",
                    this.asset.next_service_milage ? this.asset.next_service_milage : ""
                );
            }
            if (this.asset.last_battery_change) {
                formData.append(
                    "last_battery_change",
                    this.asset.last_battery_change ? this.asset.last_battery_change : ""
                );
            }
            if (this.asset.last_tyre_change) {
                formData.append(
                    "last_tyre_change",
                    this.asset.last_tyre_change ? this.asset.last_tyre_change : ""
                );
            }

            this.pageLoading = true;
            let requestTYPE = POST;
            let requestURL = "";
            if (this.equipmentId > 0) {
                requestURL = `equipment-new/${this.equipmentId}`;
            } else {
                requestURL = "equipment-new";
            }
            this.$store
                .dispatch(requestTYPE, {
                    url: requestURL,
                    data: formData,
                })
                .then((data) => {
                    this.forcePush = true;
                    if (this.isCustomer) {
                        _this.$emit("update:warranty", true);
                        _this.$emit("close:warranty", true);
                    }
                    if (!this.isCustomer) {
                        this.$router.push(
                            this.getDefaultRoute("equipment", {
                                params: { id: data.id },
                            })
                        );
                    }
                })
                .catch((error) => {
                    console.log({ error });
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
    },
    mounted() {
        this.get_options();
        this.getUserDetail();
        this.$refs.assetForm.validate();
        if (this.equipmentId > 0) {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Vehicle", route: "equipment" },
                { title: "Update" },
            ]);
        } else {
            this.ChangeGroupRadio("personal");
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Vehicle", route: "equipment" },
                { title: "Create" },
            ]);
        }
    },
    created() {
        if (!this.isCreate) {
            this.equipmentId = this.lodash.toSafeInteger(this.$route.params.id);
        }
    },

    beforeRouteLeave(to, from, next) {
        const _this = this;
        if (_this.forcePush) {
            next();
        } else if (_this.isCustomerCreated) {
            next();
        } else {
            _this.routePreventDialog = true;

            PreventDialogEventBus.$on("stay-on-page", function () {
                _this.routePreventDialog = false;
                next(false);
            });
            PreventDialogEventBus.$on("leave-page", function () {
                _this.routePreventDialog = false;
                next();
            });
        }
    },
    computed: {
        is_login_user_role() {
            const user = currentUser();
            return user?.role ? this.lodash.toSafeInteger(user?.role) : 0;
        },
        getProfileImage() {
            return this.asset.asset_image ? this.asset.asset_image : null;
        },
    },
};
</script>
